import { type FC } from 'react';

import { priceCardSkeletonDesktop, priceCardSkeletonMobile } from '@vakantiesnl/components/src/assets/skeletons';
import { SkeletonSVG } from '@vakantiesnl/components/src/atoms/Skeleton/SkeletonSVG';
import { useBreakpoints } from '@vakantiesnl/components/src/utils/useBreakpoints';

import { useCustomStyles } from './PriceCardSkeleton.style';

export const PriceCardSkeleton: FC = () => {
	const { isMobile } = useBreakpoints();
	const { classes } = useCustomStyles();
	const skeletonSvg = isMobile ? priceCardSkeletonMobile : priceCardSkeletonDesktop;

	return <SkeletonSVG svg={skeletonSvg} svgClassName={classes.skeleton} />;
};
